import React, { useState } from "react";

function TextWithReadMoreDiv({ text }) {
  const [isExpanded, setIsExpanded] = useState(false);

  // Replace \n with <br /> before splitting words
  const formattedText = text.replace(/\n/g, "<br />");
  
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = formattedText;
  const plainText = tempDiv.textContent || tempDiv.innerText || "";

  const words = plainText.split(/\s+/); // Handle multiple spaces or tabs
  const shortText = words.slice(0, 40).join(" ");
  const isLongText = words.length > 40;

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <span
        dangerouslySetInnerHTML={{
          __html: isExpanded || !isLongText
            ? formattedText
            : shortText.replace(/\n/g, "<br />") + "...",
        }}
      />
      {isLongText && (
        <span
          onClick={toggleReadMore}
          className="text-black font-medium ml-2 cursor-pointer hover:underline"
        >
          {isExpanded ? "Read Less" : "Read More"}
        </span>
      )}
    </>
  );
}

export default TextWithReadMoreDiv;
